import { render, staticRenderFns } from "./Destroy.vue?vue&type=template&id=3324a414&"
import script from "./Destroy.vue?vue&type=script&lang=js&"
export * from "./Destroy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports